import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useMemo, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { NavLink } from "react-router-dom";
import { getQueryParam } from "noood/net/xhr";
import Icon from "noood/comp/ui/feather-icon/Icon";
import { useIAppContext } from "noood/context-providers/IAppContextProvider";
import { useNavigate } from "react-router";
import FlexVertical from "noood/comp/ui/containers/flex-boxes/FlexVertical";
import FlexCenter from "noood/comp/ui/containers/flex-boxes/FlexCenter";
import Spacer from "noood/comp/ui/spacer/Spacer";
import Text from "noood/comp/text/Text";
export default function SidebarNav(props) {
  var _ref, _props$default, _useIAppContext, _displayedParent$chil, _activeMenu$content, _activeMenu2;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    rootMenuQueryValue = _useState2[0],
    setRootMenuQueryValue = _useState2[1];
  var __isVisible = function __isVisible(menu) {
    return menu.show === void 0 || menu.show === true;
  };
  var __visibleChildren = function __visibleChildren(menu) {
    var _menu$childMenus;
    return ((_menu$childMenus = menu.childMenus) !== null && _menu$childMenus !== void 0 ? _menu$childMenus : []).filter(__isVisible);
  };
  var _search = function __search(m, id, match) {
    for (var i = 0; i < m.length; i++) {
      var currentMenu = m[i];
      if (currentMenu.id === id) {
        var _childMenus$;
        var childMenus = __visibleChildren(currentMenu);
        var hasChildren = childMenus.length > 0;
        return {
          activeMenu: hasChildren ? childMenus[0] : currentMenu,
          parent: hasChildren ? currentMenu : match.parent,
          grandParent: hasChildren ? match.parent : match.grandParent,
          children: hasChildren ? (_childMenus$ = childMenus[0]) === null || _childMenus$ === void 0 ? void 0 : _childMenus$.childMenus : currentMenu.childMenus,
          depth: match.depth
        };
        /*return {
          activeMenu: currentMenu,
          parent: match.parent,
          grandParent: match.grandParent,
          children: currentMenu.childMenus,
          depth: match.depth
        }*/
      } else {
        var _childMenus = __visibleChildren(currentMenu);
        if (_childMenus.length > 0) {
          var _match$depth;
          var childMatch = _search(_childMenus, id, {
            parent: currentMenu,
            grandParent: match.parent,
            depth: ((_match$depth = match.depth) !== null && _match$depth !== void 0 ? _match$depth : 0) + 1
          });
          if (childMatch) return childMatch;
        }
      }
    }
    return undefined;
  };
  var __findFirstWithAccess = function __findFirstWithAccess(m, id, match) {
    for (var i = 0; i < m.length; i++) {
      var _childMenus$2;
      var currentMenu = m[i];
      if (!__isVisible(currentMenu)) {
        continue;
      }
      var childMenus = __visibleChildren(currentMenu);
      var hasChildren = childMenus.length > 0;
      return {
        activeMenu: hasChildren ? childMenus[0] : currentMenu,
        parent: hasChildren ? currentMenu : match.parent,
        grandParent: hasChildren ? match.parent : match.grandParent,
        children: hasChildren ? (_childMenus$2 = childMenus[0]) === null || _childMenus$2 === void 0 ? void 0 : _childMenus$2.childMenus : currentMenu.childMenus,
        depth: match.depth
      };
    }
    return undefined;
  };
  var __checkIfWithAccessOrLookForFirstMenuWithAccess = function __checkIfWithAccessOrLookForFirstMenuWithAccess(defaultMenuId) {
    var supposedDefault = _search(props.menu, defaultMenuId, {});
    if (supposedDefault !== null && supposedDefault !== void 0 && supposedDefault.activeMenu) {
      return supposedDefault.activeMenu.id;
    }
    // look for the first menu that this user has access to
    var firstWithAccess = __findFirstWithAccess(props.menu, defaultMenuId, {});
    return firstWithAccess === null || firstWithAccess === void 0 ? void 0 : firstWithAccess.activeMenu.id;
  };
  var menu = props.menu,
    queryStringFilter = props.queryStringFilter;
  var pgValueWithoutDefault = getQueryParam(queryStringFilter);
  var pg = (_ref = pgValueWithoutDefault !== null && pgValueWithoutDefault !== void 0 ? pgValueWithoutDefault : __checkIfWithAccessOrLookForFirstMenuWithAccess((_props$default = props["default"]) !== null && _props$default !== void 0 ? _props$default : "list")) !== null && _ref !== void 0 ? _ref : "list";
  var isDarkMode = ((_useIAppContext = useIAppContext()) === null || _useIAppContext === void 0 ? void 0 : _useIAppContext.lightOrDark) === 'dark';
  var navigate = useNavigate();
  var ancestry = useMemo(function () {
    if (pg) {
      return _search(props.menu, pg, {});
    }
    return {};
  }, [pg, props.menu]);
  var _ref2 = ancestry ? ancestry : {},
    activeMenu = _ref2.activeMenu,
    parent = _ref2.parent,
    grandParent = _ref2.grandParent,
    children = _ref2.children;
  var hasActiveMenu = activeMenu !== void 0 && activeMenu !== null;
  var activeChildren = activeMenu ? __visibleChildren(activeMenu) : [];
  if (activeChildren.length > 0) {
    grandParent = parent;
    parent = activeMenu;
    activeMenu = activeChildren[0];
  }
  var showRootMenu = rootMenuQueryValue === pg;
  var displayedParent = showRootMenu ? undefined : parent;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.nav_col, (pgValueWithoutDefault === void 0 || pgValueWithoutDefault === null) && ui.pg_value_void_mobile), {
    style: {
      backgroundColor: isDarkMode ? '#443e49' : "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "SidebarNav__ui.menu_container ev78zum5 evdt5ytf ev1nejdyq ev7z7khe evo5ses6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SidebarNav__ui.header_container evyorhqc evm1edtm evle4ggd ev1kbzgg6 ev133i0un"
  }, props.header ? props.header : /*#__PURE__*/React.createElement(React.Fragment, null, (props.navTitle || props.navCaption) && /*#__PURE__*/React.createElement(FlexVertical, {
    gap: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "SidebarNav__ui.nav_title ev174oaz8"
  }, props.navTitle), /*#__PURE__*/React.createElement("div", {
    className: "SidebarNav__ui.nav_caption evytml03 ev78gv6v eviujj5z"
  }, props.navCaption)))), displayedParent && /*#__PURE__*/React.createElement(React.Fragment, null, grandParent ? /*#__PURE__*/React.createElement(NavLink, _extends({}, {
    className: "SidebarNav__ui.selected_parent ev78zum5 ev1nejdyq ev1ypdohk"
  }, {
    to: "".concat(grandParent ? "?".concat(props.queryStringFilter, "=").concat(grandParent.id) : "")
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrow-left"
  })), /*#__PURE__*/React.createElement("div", null, parent.title)) : /*#__PURE__*/React.createElement("div", _extends({
    onClick: function onClick() {
      setRootMenuQueryValue(pg);
    }
  }, {
    className: "SidebarNav__ui.selected_parent ev1nejdyq ev1ypdohk SidebarNav__ui.back_container ev78zum5 ev6s0dn4 evx754bn ev1xpd4zr"
  }), /*#__PURE__*/React.createElement("div", {
    className: "SidebarNav__ui.back_button ev1ypdohk ev1h2kqdt ev16cph09 ev52rwoh evqow0kl evrh9tz8 ev1mybsiy ev17ayjw1 ev78zum5 ev6s0dn4 evl56j7k"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrow-left"
  })), /*#__PURE__*/React.createElement("div", null, parent.title))), /*#__PURE__*/React.createElement("div", {
    className: "SidebarNav__ui.menu_item_container ev78zum5 evdt5ytf ev1caa2vd evx754bn"
  }, ((_displayedParent$chil = displayedParent === null || displayedParent === void 0 ? void 0 : displayedParent.childMenus) !== null && _displayedParent$chil !== void 0 ? _displayedParent$chil : menu).filter(__isVisible).map(function (subMenu, idx) {
    var _activeMenu, _parent;
    var childMenus = __visibleChildren(subMenu);
    var hasChildren = childMenus.length > 0;
    var firstChild = childMenus[0];
    var targetMenuId = hasChildren ? firstChild.id : subMenu.id;
    var isActive = ((_activeMenu = activeMenu) === null || _activeMenu === void 0 ? void 0 : _activeMenu.id) === subMenu.id || hasChildren && ((_parent = parent) === null || _parent === void 0 ? void 0 : _parent.id) === subMenu.id;
    return /*#__PURE__*/React.createElement(NavLink, _extends({
      key: "sidebar-nav-item-".concat(idx, "-").concat(subMenu.id),
      to: "?".concat(queryStringFilter, "=").concat(targetMenuId)
    }, stylex.props(ui.menu, isActive && ui.menu_active, (pgValueWithoutDefault === void 0 || pgValueWithoutDefault === null) && ui.nav_item_no_pg_for_mobile), {
      /*style={{
        color: activeMenu?.id === subMenu.id
          ? color.determineCorrectTextContrast(
            color.extractCSSValue(`--accent`)
          ) : `var(--shade-80)`
      }}*/
      onClick: function onClick(e) {
        e.preventDefault();
        if (subMenu.__click) {
          subMenu.__click();
        } else {
          setRootMenuQueryValue(null);
          navigate("?".concat(props.queryStringFilter, "=").concat(targetMenuId));
        }
      }
    }), subMenu.icon && /*#__PURE__*/React.createElement("div", {
      className: "SidebarNav__ui.icon_container evtv37m0 evrtf5rt"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: subMenu.icon,
      useStyle: false,
      stylexStyles: [ui.icon, isActive && ui.icon_active, (pgValueWithoutDefault === void 0 || pgValueWithoutDefault === null) && ui.nav_icon_no_pg_for_mobile]
    })), /*#__PURE__*/React.createElement("div", {
      className: "SidebarNav__ui.menu_title ev98rzlu ev78gv6v ev1duzd8e"
    }, subMenu.title), subMenu.counter !== void 0 && Number(subMenu.counter) > 1 && /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12
      }
    }, subMenu.counter), hasChildren && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      icon: "chevron-right"
    })));
  })))), /*#__PURE__*/React.createElement("div", stylex.props(ui.nav_content, (pgValueWithoutDefault === void 0 || pgValueWithoutDefault === null || !hasActiveMenu) && ui.pg_value_void_mobile), /*#__PURE__*/React.createElement(React.Fragment, null, (_activeMenu$content = (_activeMenu2 = activeMenu) === null || _activeMenu2 === void 0 ? void 0 : _activeMenu2.content) !== null && _activeMenu$content !== void 0 ? _activeMenu$content : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 40
  }), /*#__PURE__*/React.createElement(FlexCenter, {
    direction: 'column',
    gap: 8
  }, /*#__PURE__*/React.createElement(Text, {
    size: 22
  }, "Not Found"), /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    center: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, "The page you are looking for", /*#__PURE__*/React.createElement("br", null), "might have moved, does not exist,", /*#__PURE__*/React.createElement("br", null), "\xA0or a page you probably don't", /*#__PURE__*/React.createElement("br", null), "have access right now.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Please try again later.")))))));
}

// @ts-ignore
_inject(".evixxii4{position:fixed}", 3000);
_inject(".evzkaem6{z-index:3}", 3000);
_inject(".ev13vifvy{top:0}", 4000);
_inject(".ev1oysuqx{width:200px}", 4000);
_inject(".ev1ey2m1c{bottom:0}", 4000);
_inject(".ev1odjw0f{overflow-y:auto}", 4000);
_inject(".ev17tlody{border-right:1px solid var(--shade-10)}", 2000);
_inject("@media(min-width:501px){.ev1rdy60x.ev1rdy60x{left:70px}}", 4200);
_inject("@media(max-width:500px){.ev103ggzd.ev103ggzd{left:0}}", 4200);
_inject("@media(max-width:500px){.ev1afdwag.ev1afdwag{display:none}}", 3200);
_inject(".evhtitgo{z-index:2}", 3000);
_inject(".ev3m8u43{right:0}", 4000);
_inject("@media(min-width:501px){.evbw5gen.evbw5gen{left:270px}}", 4200);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".evdt5ytf{flex-direction:column}", 3000);
_inject(".ev1nejdyq{gap:5px}", 2000);
_inject(".ev7z7khe{padding:10px}", 1000);
_inject(".evo5ses6{padding-bottom:70px}", 4000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".ev8lhhth{padding:5px 8px}", 1000);
_inject(".ev1hl2dhg{text-decoration:none}", 2000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".ev12p33jh:active{background-color:var(--shade-15)}", 3170);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject("@media(min-width: 501px){.ev3066x5.ev3066x5{border-radius:var(--roundness)}}", 2200);
_inject("@media(max-width:500px){.evx754bn.evx754bn{padding:10px}}", 1200);
_inject("@media(max-width:500px){.evxndvbq.evxndvbq{border-bottom:1px solid var(--shade-05)}}", 2200);
_inject("@media(max-width:500px){.evxzh24n.evxzh24n:first-of-type{border-top-left-radius:15px}}", 4253);
_inject("@media(max-width:500px){.ev19aq9nv.ev19aq9nv:first-of-type{border-top-right-radius:15px}}", 4253);
_inject("@media(max-width:500px){.evi2iv0z.evi2iv0z:last-of-type{border-bottom-left-radius:15px}}", 4255);
_inject("@media(max-width:500px){.evqunv1j.evqunv1j:last-of-type{border-bottom-right-radius:15px}}", 4255);
_inject("@media(max-width:500px){.evhgnuop.evhgnuop:last-of-type{border-bottom:0}}", 2255);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
_inject("@media(max-width:500px){.ev1p4rz49.ev1p4rz49{right:0}}", 4200);
_inject("@media(max-width:500px){.ev5d2s78.ev5d2s78{width:unset}}", 4200);
_inject("@media(max-width:500px){.evxmhpu1.evxmhpu1{display:block}}", 3200);
_inject("@media(min-width:501px){.ev1caa2vd.ev1caa2vd{gap:7px}}", 2200);
_inject(".evyorhqc{margin-bottom:10px}", 4000);
_inject("@media(max-width:500px){.evm1edtm.evm1edtm{display:flex}}", 3200);
_inject("@media(max-width:500px){.evle4ggd.evle4ggd{justify-content:center}}", 3200);
_inject("@media(max-width:500px){.ev1kbzgg6.ev1kbzgg6{text-align:center}}", 3200);
_inject("@media(max-width:500px){.ev133i0un.ev133i0un{margin-top:15px}}", 4200);
_inject("@media(max-width:500px){.evtv37m0.evtv37m0{margin-right:10px}}", 4200);
_inject("@media(max-width:500px){.evrtf5rt.evrtf5rt{margin-left:5px}}", 4200);
_inject("@media(max-width:500px){.evxkcamx.evxkcamx{font-size:20px}}", 3200);
_inject("@media(max-width:500px){.ev992iig.ev992iig{color:var(--accent)}}", 3200);
_inject("@media(max-width:500px){.ev13vgm90.ev13vgm90{color:var(--text-on-accent)}}", 3200);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject("@media(max-width:500px){.ev16cph09.ev16cph09{background-color:var(--shade-05)}}", 3200);
_inject("@media(max-width:500px){.ev52rwoh.ev52rwoh:hover{background-color:var(--shade-10)}}", 3330);
_inject("@media(max-width:500px){.evqow0kl.evqow0kl:active{background-color:var(--shade-15)}}", 3370);
_inject("@media(max-width:500px){.evrh9tz8.evrh9tz8{width:30px}}", 4200);
_inject("@media(max-width:500px){.ev1mybsiy.ev1mybsiy{height:30px}}", 4200);
_inject("@media(max-width:500px){.ev17ayjw1.ev17ayjw1{border-radius:30px}}", 2200);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject("@media(max-width:500px){.ev1xpd4zr.ev1xpd4zr{gap:10px}}", 2200);
_inject("@media(max-width:500px){.ev88uics.ev88uics{color:var(--text-color)}}", 3200);
_inject(".ev98rzlu{flex:1}", 2000);
_inject("@media(min-width:501px){.ev78gv6v.ev78gv6v{font-size:14px}}", 3200);
_inject("@media(max-width:500px){.ev1duzd8e.ev1duzd8e{font-size:17px}}", 3200);
_inject("@media(max-width:500px){.ev174oaz8.ev174oaz8{font-size:18px}}", 3200);
_inject(".evytml03{color:var(--shade-50)}", 3000);
_inject("@media(max-width:500px){.eviujj5z.eviujj5z{font-size:14px}}", 3200);
var ui = {
  nav_col: {
    "SidebarNav__ui.nav_col": "SidebarNav__ui.nav_col",
    position: "evixxii4",
    zIndex: "evzkaem6",
    top: "ev13vifvy",
    width: "ev1oysuqx",
    bottom: "ev1ey2m1c",
    overflowY: "ev1odjw0f",
    borderRight: "ev17tlody",
    borderRightWidth: null,
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderRightStyle: null,
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderRightColor: null,
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    "@media(min-width:501px)_left": "ev1rdy60x",
    "@media(min-width:501px)_insetInlineStart": null,
    "@media(min-width:501px)_insetInlineEnd": null,
    "@media(max-width:500px)_left": "ev103ggzd",
    "@media(max-width:500px)_insetInlineStart": null,
    "@media(max-width:500px)_insetInlineEnd": null,
    "@media(max-width:500px)_display": "ev1afdwag",
    $$css: true
  },
  nav_content: {
    "SidebarNav__ui.nav_content": "SidebarNav__ui.nav_content",
    position: "evixxii4",
    top: "ev13vifvy",
    bottom: "ev1ey2m1c",
    zIndex: "evhtitgo",
    right: "ev3m8u43",
    insetInlineStart: null,
    insetInlineEnd: null,
    overflowY: "ev1odjw0f",
    "@media(max-width:500px)_left": "ev103ggzd",
    "@media(max-width:500px)_insetInlineStart": null,
    "@media(max-width:500px)_insetInlineEnd": null,
    "@media(min-width:501px)_left": "evbw5gen",
    "@media(min-width:501px)_insetInlineStart": null,
    "@media(min-width:501px)_insetInlineEnd": null,
    $$css: true
  },
  menu: {
    "SidebarNav__ui.menu": "SidebarNav__ui.menu",
    cursor: "ev1ypdohk",
    transition: "ev1m3phxg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    padding: "ev8lhhth",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    textDecoration: "ev1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    backgroundColor: "ev1y7ric0 ev3dtjww ev12p33jh",
    display: "ev78zum5",
    gap: "ev1nejdyq",
    rowGap: null,
    columnGap: null,
    alignItems: "ev6s0dn4",
    "@media(min-width: 501px)_borderRadius": "ev3066x5",
    "@media(min-width: 501px)_borderStartStartRadius": null,
    "@media(min-width: 501px)_borderStartEndRadius": null,
    "@media(min-width: 501px)_borderEndStartRadius": null,
    "@media(min-width: 501px)_borderEndEndRadius": null,
    "@media(min-width: 501px)_borderTopLeftRadius": null,
    "@media(min-width: 501px)_borderTopRightRadius": null,
    "@media(min-width: 501px)_borderBottomLeftRadius": null,
    "@media(min-width: 501px)_borderBottomRightRadius": null,
    "@media(max-width:500px)_padding": "evx754bn",
    "@media(max-width:500px)_paddingInline": null,
    "@media(max-width:500px)_paddingStart": null,
    "@media(max-width:500px)_paddingLeft": null,
    "@media(max-width:500px)_paddingEnd": null,
    "@media(max-width:500px)_paddingRight": null,
    "@media(max-width:500px)_paddingBlock": null,
    "@media(max-width:500px)_paddingTop": null,
    "@media(max-width:500px)_paddingBottom": null,
    "@media(max-width:500px)_borderBottom": "evxndvbq",
    "@media(max-width:500px)_borderBottomWidth": null,
    "@media(max-width:500px)_borderBottomStyle": null,
    "@media(max-width:500px)_borderBottomColor": null,
    "@media(max-width:500px)_:first-of-type_borderTopLeftRadius": "evxzh24n",
    "@media(max-width:500px)_:first-of-type_borderStartStartRadius": null,
    "@media(max-width:500px)_:first-of-type_borderStartEndRadius": null,
    "@media(max-width:500px)_:first-of-type_borderTopRightRadius": "ev19aq9nv",
    "@media(max-width:500px)_:last-of-type_borderBottomLeftRadius": "evi2iv0z",
    "@media(max-width:500px)_:last-of-type_borderEndStartRadius": null,
    "@media(max-width:500px)_:last-of-type_borderEndEndRadius": null,
    "@media(max-width:500px)_:last-of-type_borderBottomRightRadius": "evqunv1j",
    "@media(max-width:500px)_:last-of-type_borderBottom": "evhgnuop",
    "@media(max-width:500px)_:last-of-type_borderBottomWidth": null,
    "@media(max-width:500px)_:last-of-type_borderBottomStyle": null,
    "@media(max-width:500px)_:last-of-type_borderBottomColor": null,
    $$css: true
  },
  menu_active: {
    "SidebarNav__ui.menu_active": "SidebarNav__ui.menu_active",
    backgroundColor: "evwnonoy",
    color: "ev1tzx33q",
    $$css: true
  },
  pg_value_void_mobile: {
    "SidebarNav__ui.pg_value_void_mobile": "SidebarNav__ui.pg_value_void_mobile",
    "@media(max-width:500px)_right": "ev1p4rz49",
    "@media(max-width:500px)_insetInlineStart": null,
    "@media(max-width:500px)_insetInlineEnd": null,
    "@media(max-width:500px)_width": "ev5d2s78",
    "@media(max-width:500px)_display": "evxmhpu1",
    $$css: true
  },
  icon: {
    "SidebarNav__ui.icon": "SidebarNav__ui.icon",
    "@media(max-width:500px)_fontSize": "evxkcamx",
    "@media(max-width:500px)_color": "ev992iig",
    $$css: true
  },
  icon_active: {
    "SidebarNav__ui.icon_active": "SidebarNav__ui.icon_active",
    "@media(max-width:500px)_color": "ev13vgm90",
    $$css: true
  },
  nav_item_no_pg_for_mobile: {
    "SidebarNav__ui.nav_item_no_pg_for_mobile": "SidebarNav__ui.nav_item_no_pg_for_mobile",
    "@media(max-width:500px)_backgroundColor": "ev16cph09 ev52rwoh evqow0kl",
    "@media(max-width:500px)_color": "ev88uics",
    $$css: true
  },
  nav_icon_no_pg_for_mobile: {
    "SidebarNav__ui.nav_icon_no_pg_for_mobile": "SidebarNav__ui.nav_icon_no_pg_for_mobile",
    "@media(max-width:500px)_color": "ev992iig",
    $$css: true
  }
};